import React from 'react';

// Heritage Crest Logo Component
const Logo = ({ variant = 'header', color = 'gold' }) => {
  const colorValue = color === 'gold' ? '#D4AF37' : '#000000';
  
  if (variant === 'header') {
    // Horizontal layout: shield to the left of name
    return (
      <div style={{
        display: 'flex',
        alignItems: 'center',
        gap: '12px'
      }}>
        <div style={{
          width: '32px',
          height: '38px',
          border: `1.5px solid ${colorValue}`,
          borderRadius: '0 0 16px 16px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          position: 'relative'
        }}>
          <div style={{
            position: 'absolute',
            top: '-1.5px',
            left: '-1.5px',
            right: '-1.5px',
            height: '10px',
            border: `1.5px solid ${colorValue}`,
            borderBottom: 'none'
          }} />
          <span style={{
            fontFamily: 'Playfair Display, serif',
            fontSize: '15px',
            fontWeight: '600',
            color: colorValue
          }}>PT</span>
        </div>
        <span style={{
          fontFamily: 'Cormorant Garamond, serif',
          fontSize: '20px',
          fontWeight: '500',
          color: colorValue,
          letterSpacing: '2px',
          textTransform: 'uppercase'
        }}>PROMESA TRADING</span>
      </div>
    );
  }
  
  // Footer/stacked layout: shield above name
  return (
    <div style={{
      textAlign: 'center',
      display: 'inline-block'
    }}>
      <div style={{
        width: '50px',
        height: '60px',
        border: `2px solid ${colorValue}`,
        borderRadius: '0 0 25px 25px',
        margin: '0 auto 12px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative'
      }}>
        <div style={{
          position: 'absolute',
          top: '-2px',
          left: '-2px',
          right: '-2px',
          height: '16px',
          border: `2px solid ${colorValue}`,
          borderBottom: 'none'
        }} />
        <span style={{
          fontFamily: 'Playfair Display, serif',
          fontSize: '20px',
          fontWeight: '600',
          color: colorValue
        }}>PT</span>
      </div>
      <div style={{
        fontFamily: 'Cormorant Garamond, serif',
        fontSize: '22px',
        fontWeight: '500',
        color: colorValue,
        letterSpacing: '2px',
        textTransform: 'uppercase',
        marginBottom: '4px'
      }}>PROMESA</div>
      <div style={{
        fontFamily: 'Cormorant Garamond, serif',
        fontSize: '22px',
        fontWeight: '500',
        color: colorValue,
        letterSpacing: '2px',
        textTransform: 'uppercase'
      }}>TRADING</div>
      <div style={{
        fontFamily: 'Cormorant Garamond, serif',
        fontSize: '10px',
        fontWeight: '400',
        color: colorValue,
        letterSpacing: '1.5px',
        marginTop: '8px',
        opacity: 0.6
      }}>EST. 1989</div>
    </div>
  );
};

export default Logo;